export const DemoJson = `{
  "key1":"value1",
  "key2":"value2"
}`;
